import React from 'react'
import ReactDOM from 'react-dom'
import {Router, Route, Routes, useNavigate } from "react-router-dom";
import Result from "./components/pages/Result";
import SignIn from "./components/pages/SignIn";
import SignUp from "./components/pages/SignUp";
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AdminProtectedRoute } from './components/AdminProtectedRoute'
import  ApproveRetake  from './components/pages/ApproveRetake'
import  ForgotPassword  from './components/pages/ForgotPassword'
import  About  from './components/pages/About'
import  PageNotFound  from './components/pages/PageNotFound'
import { useAuth } from "./context/AuthContext";
import Quiz from "./Quiz";
import Admin from "./Admin";
import UserActivity from "./userActivity.jsx";

function App() {
  
  return (
    <>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<SignIn/>}/>
          <Route path="/forgot-password" element={<ForgotPassword/>}/>
          <Route path="/signup" element={<SignUp/>}/>
          <Route path="/about" element={<About/>}/>
          <Route path='/quiz' element={
            <ProtectedRoute>
            <Quiz/>
          </ProtectedRoute> 
          }/>
          <Route path="/result" element={<Result/>}/>
          <Route path='/admin' element={
            <AdminProtectedRoute>
              <Admin/>
            </AdminProtectedRoute> 
          }/>
          <Route path='/userActivity' element={
            <AdminProtectedRoute>
              <UserActivity />
            </AdminProtectedRoute>
          } />
          <Route path='/approve-retake/:uid' element={<ApproveRetake/>}/>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;
